"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2893],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 68185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Switch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9135);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54520);
// ../../../react-shim.js


// src/switch.tsx



// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;

// src/switch.tsx

var Switch = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function Switch2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Switch", props);
  const { spacing = "0.5rem", children, ...ownProps } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const {
    state,
    getInputProps,
    getCheckboxProps,
    getRootProps,
    getLabelProps
  } = (0,_chakra_ui_checkbox__WEBPACK_IMPORTED_MODULE_3__/* .useCheckbox */ .O)(ownProps);
  const containerStyles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    display: "inline-block",
    position: "relative",
    verticalAlign: "middle",
    lineHeight: 0,
    ...styles.container
  }), [styles.container]);
  const trackStyles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    display: "inline-flex",
    flexShrink: 0,
    justifyContent: "flex-start",
    boxSizing: "content-box",
    cursor: "pointer",
    ...styles.track
  }), [styles.track]);
  const labelStyles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    userSelect: "none",
    marginStart: spacing,
    ...styles.label
  }), [spacing, styles.label]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.label */ .m$.label, {
    ...getRootProps(),
    className: cx("chakra-switch", props.className),
    __css: containerStyles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    className: "chakra-switch__input",
    ...getInputProps({}, ref)
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.span */ .m$.span, {
    ...getCheckboxProps(),
    className: "chakra-switch__track",
    __css: trackStyles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.span */ .m$.span, {
    __css: styles.thumb,
    className: "chakra-switch__thumb",
    "data-checked": dataAttr(state.isChecked),
    "data-hover": dataAttr(state.isHovered)
  })), children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.span */ .m$.span, {
    className: "chakra-switch__label",
    ...getLabelProps(),
    __css: labelStyles
  }, children));
});
Switch.displayName = "Switch";



/***/ }),

/***/ 96396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66866);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12261);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const Actions = _ref => {
  let {
    active,
    primary,
    hasSecondaryAction,
    secondary,
    inline
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SimpleGrid */ .MI, {
    columns: {
      base: inline && hasSecondaryAction ? 2 : 1,
      md: inline ? 2 : 1
    },
    spacing: {
      base: '1rem',
      md: inline ? '1.5rem' : '.5rem'
    },
    children: [hasSecondaryAction && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      title: secondary.title,
      action: secondary.action,
      onClick: secondary.onClick
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      title: primary.title,
      action: primary.action,
      onClick: primary.onClick,
      disabled: !active
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Actions);

/***/ }),

/***/ 2893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_OfferDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/switch/dist/index.esm.js
var dist_index_esm = __webpack_require__(68185);
// EXTERNAL MODULE: ./src/uikit/Lists/Simple.tsx + 1 modules
var Simple = __webpack_require__(72954);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(26869);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Title.tsx






const Title = _ref => {
  let {
    title,
    subtitle,
    brandImage,
    brandImageAlt
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
    templateColumns: {
      base: '1fr',
      md: '0.25fr 1fr'
    },
    alignItems: "center",
    children: [brandImage && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      p: 0,
      m: 0,
      h: "60px",
      display: {
        base: 'none',
        md: 'block'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        objectFit: "contain",
        src: brandImage,
        width: "60",
        height: "60",
        alt: brandImageAlt
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        as: "h1",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.75rem",
        letterSpacing: "0.86px",
        mt: "-7px",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        marginTop: "xs",
        color: "baseNeutral.700",
        fontFamily: "Montserrat-Medium",
        fontSize: "1.125rem",
        textTransform: "capitalize",
        lineHeight: "23.4px",
        letterSpacing: "0.3px",
        children: subtitle
      })]
    })]
  });
};

/* harmony default export */ var OfferDetails_Title = (Title);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/uikit/Badges/WithIcon.tsx
var WithIcon = __webpack_require__(93531);
// EXTERNAL MODULE: ./src/uikit/Boxes/Price.tsx
var Price = __webpack_require__(64673);
// EXTERNAL MODULE: ./src/icons/green_fuel.tsx
var green_fuel = __webpack_require__(49470);
// EXTERNAL MODULE: ./src/icons/green_transmission.tsx
var green_transmission = __webpack_require__(46378);
// EXTERNAL MODULE: ./src/icons/green_power.tsx
var green_power = __webpack_require__(12505);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Description.tsx


const _excluded = ["icon", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








const BadgeWithIconCustom = _ref => {
  let {
    icon,
    name,
    value
  } = _ref,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WithIcon/* default */.Z, _objectSpread({
    icon: icon,
    name: name,
    value: value,
    fontFamily: "Montserrat-Regular, san-serif",
    fontSize: ".875rem",
    color: "#262626",
    marginBottom: "6px"
  }, others));
};

const Description = _ref2 => {
  let {
    fuelTitle,
    fuelValue,
    transmissionTitle,
    transmissionValue,
    powerTitle,
    powerValue,
    priceValue,
    priceDescription
  } = _ref2;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    textAlign: "left",
    position: "relative",
    marginTop: "1.3rem!important",
    marginBottom: "0",
    marginLeft: "-3px",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_fuel/* default */.Z, {}),
      name: fuelTitle,
      value: fuelValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_transmission/* default */.Z, {}),
      name: transmissionTitle,
      value: transmissionValue,
      marginLeft: "-2px"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWithIconCustom, {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_power/* default */.Z, {}),
      name: powerTitle,
      value: powerValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Price/* default */.Z, {
      value: priceValue,
      description: priceDescription,
      textAlign: "right",
      position: "absolute",
      top: "-3px",
      right: "0"
    })]
  });
};

/* harmony default export */ var OfferDetails_Description = (Description);
// EXTERNAL MODULE: ./src/uikit/Badges/LimitedOffer.tsx + 1 modules
var LimitedOffer = __webpack_require__(94999);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
;// CONCATENATED MODULE: ./src/uikit/Buttons/Card.tsx





const StyledCardButton = /*#__PURE__*/styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-11y6dfm-0"
})(["display:inline;& svg{margin:auto;}"]);

const CardButton = _ref => {
  let {
    icon,
    title,
    description,
    onHoverMessage,
    onClick
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCardButton, {
    title: onClick ? onHoverMessage : '',
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      backgroundColor: "baseWhite",
      borderRadius: 10,
      width: "100%",
      height: "100%",
      minHeight: "6.125rem",
      display: "inline-block",
      mt: "0.34rem",
      boxShadow: "0 2px 4px 0px rgba(0, 0, 0, 0.08)",
      cursor: onClick ? 'pointer' : 'default',
      padding: "xs",
      textAlign: "center",
      _hover: {
        textDecoration: 'none',
        boxShadow: '0 4px 12px 0px rgba(65, 164, 118, 0.22)'
      },
      onClick: onClick,
      children: [icon, /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Medium",
        fontSize: "0.75rem",
        lineHeight: "15.6px",
        letterSpacing: "0.4px",
        marginTop: "xs",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        marginTop: "xxs",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "0.875rem",
        lineHeight: "18px",
        letterSpacing: "0.2px",
        children: description
      })]
    })
  });
};

/* harmony default export */ var Card = (CardButton);
;// CONCATENATED MODULE: ./src/icons/green_calendar.tsx



const GreenCalendarIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(-1026 -326) translate(974 172) translate(1 146) translate(51 8)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "16",
        cy: "16",
        r: "16",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M9.031 13.25H7.47c-.258 0-.469-.21-.469-.469V11.22c0-.258.21-.469.469-.469H9.03c.258 0 .469.21.469.469v1.562c0 .258-.21.469-.469.469zm4.219-.469V11.22c0-.258-.21-.469-.469-.469H11.22c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469h1.562c.258 0 .469-.21.469-.469zm3.75 0V11.22c0-.258-.21-.469-.469-.469H14.97c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469h1.562c.258 0 .469-.21.469-.469zm-3.75 3.75V14.97c0-.258-.21-.469-.469-.469H11.22c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469h1.562c.258 0 .469-.21.469-.469zm-3.75 0V14.97c0-.258-.21-.469-.469-.469H7.47c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469H9.03c.258 0 .469-.21.469-.469zm7.5 0V14.97c0-.258-.21-.469-.469-.469H14.97c-.258 0-.469.21-.469.469v1.562c0 .258.21.469.469.469h1.562c.258 0 .469-.21.469-.469zm3.75-10.156v13.75c0 1.035-.84 1.875-1.875 1.875H5.125c-1.035 0-1.875-.84-1.875-1.875V6.375c0-1.035.84-1.875 1.875-1.875H7V2.469C7 2.21 7.21 2 7.469 2H9.03c.258 0 .469.21.469.469V4.5h5V2.469c0-.258.21-.469.469-.469h1.562c.258 0 .469.21.469.469V4.5h1.875c1.035 0 1.875.84 1.875 1.875zm-1.875 13.516V8.25H5.125v11.64c0 .13.105.235.234.235h13.282c.129 0 .234-.105.234-.234z",
          transform: "translate(4 4)"
        })
      })]
    })
  })
});

/* harmony default export */ var green_calendar = (GreenCalendarIcon);
;// CONCATENATED MODULE: ./src/icons/green_car_2.tsx



const GreenCarIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "32",
  viewBox: "0 0 33 32",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(-1171 -326) translate(974 172) translate(145 146) translate(52.008 8)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "16",
        cy: "16",
        r: "16",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M4.187 19c.518 0 .938-.42.938-.937v-.938h13.75v.938c0 .517.42.937.937.937h.625c.518 0 .938-.42.938-.937V12.75c0-.687-.197-1.322-.52-1.875h.442c.215 0 .402-.146.454-.355l.235-.937c.074-.296-.15-.583-.455-.583h-2.04l-1.225-3.042C17.791 4.775 16.643 4 15.368 4H8.632c-1.275 0-2.423.775-2.899 1.958L4.508 9H2.47c-.305 0-.529.287-.455.582l.235.938c.049.196.252.355.454.355h.442c-.323.553-.52 1.188-.52 1.875v5.313c0 .517.42.937.937.937h.625zM17.47 9H6.53l.943-2.342c.19-.476.646-.783 1.159-.783h6.736c.513 0 .968.307 1.16.783L17.47 9zm1.405 6.25H5.125c-.345 0-.625-.28-.625-.625V12.75c0-1.034.84-1.875 1.875-1.875h11.25c1.034 0 1.875.841 1.875 1.875v1.875c0 .345-.28.625-.625.625zm-10-1.568c0-.748-1.125-1.87-1.875-1.87s-1.25.499-1.25 1.247c0 .748.5 1.246 1.25 1.246s1.875.125 1.875-.623zm8.125.623c.75 0 1.25-.498 1.25-1.246s-.5-1.247-1.25-1.247-1.875 1.122-1.875 1.87 1.125.623 1.875.623z",
          transform: "translate(4 4)"
        })
      })]
    })
  })
});

/* harmony default export */ var green_car_2 = (GreenCarIcon);
;// CONCATENATED MODULE: ./src/icons/green_pocket.tsx



const GreenPocketIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "32",
  viewBox: "0 0 33 32",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(-1312 -326) translate(974 172) translate(292 146) translate(46.466 8)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "16",
        cy: "16",
        r: "16",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M19.5 20.273c1.38 0 2.5-1.105 2.5-2.468V8.552c0-1.363-1.12-2.468-2.5-2.468v-.616C19.5 4.105 18.38 3 17 3H5.75C3.679 3 2 4.657 2 6.701v9.87c0 2.045 1.679 3.702 3.75 3.702H19.5zm0-1.85H5.75c-1.034 0-1.875-.831-1.875-1.852v-9.87c0-1.02.841-1.85 1.875-1.85H17c.345 0 .625.276.625.617V6.7H6.375c-.345 0-.625.276-.625.617 0 .341.28.617.625.617H19.5c.345 0 .625.277.625.617v9.253c0 .34-.28.617-.625.617zm-2.5-4.32c.69 0 1.25-.552 1.25-1.233s-.56-1.234-1.25-1.234-1.25.553-1.25 1.234c0 .681.56 1.234 1.25 1.234z",
          transform: "translate(4 4)"
        })
      })]
    })
  })
});

/* harmony default export */ var green_pocket = (GreenPocketIcon);
;// CONCATENATED MODULE: ./src/components/OfferDetails/Offer.tsx







const OfferDetails = _ref => {
  let {
    sectionTitle,
    durationTitle,
    durationValue,
    distanceTitle,
    distanceValue,
    depositTitle,
    depositValue,
    depositDescription,
    hasDepositChoice,
    onHoverMessage,
    expirationValue,
    onClick
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      textAlign: "left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        display: "inline",
        fontSize: "1rem",
        lineHeight: "30.8x",
        letterSpacing: "0.2px",
        children: sectionTitle
      }), expirationValue && expirationValue.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(LimitedOffer/* default */.Z, {
        display: "inline",
        float: "right",
        children: expirationValue
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
      columns: hasDepositChoice ? 2 : 3,
      spacing: ".688rem",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_calendar, {}),
        title: durationTitle,
        description: durationValue,
        onHoverMessage: onHoverMessage,
        onClick: onClick
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_car_2, {}),
        title: distanceTitle,
        description: distanceValue,
        onHoverMessage: onHoverMessage,
        onClick: onClick
      }), !hasDepositChoice && /*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_pocket, {}),
        title: depositTitle,
        description: `${depositValue} ${depositDescription}`,
        onHoverMessage: onHoverMessage,
        onClick: onClick
      })]
    })]
  });
};

/* harmony default export */ var Offer = (OfferDetails);
// EXTERNAL MODULE: ./src/components/OfferDetails/Actions.tsx
var Actions = __webpack_require__(96396);
;// CONCATENATED MODULE: ./src/components/OfferDetails/index.tsx













const ChooseDeposit = dynamic_default()(() => __webpack_require__.e(/* import() */ 7326).then(__webpack_require__.bind(__webpack_require__, 67326)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(67326)]
  }
});
const OfferDetails_OfferDetails = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    title,
    subtitle,
    brandImage,
    brandImageAlt,
    sectionTitle,
    durationTitle,
    durationValue,
    distanceValue,
    distanceTitle,
    depositTitle,
    depositValue,
    depositDescription,
    hasDepositChoice,
    expirationValue,
    onHoverMessage,
    onClick,
    offerData,
    fuelTitle,
    fuelValue,
    transmissionTitle,
    transmissionValue,
    powerTitle,
    powerValue,
    priceValue,
    priceDescription,
    insurances,
    active,
    primary,
    hasSecondaryAction,
    secondary
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();
  const priceVatIncluded = (0,es/* useSelector */.v9)(state => state.nlt.priceVatIncluded);
  const {
    0: priceVatIncludedChecked,
    1: setPriceVatIncludedChecked
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => setPriceVatIncludedChecked(!priceVatIncluded), [priceVatIncluded]);

  const togglePriceVatIncluded = () => {
    setPriceVatIncludedChecked(!priceVatIncludedChecked);
    dispatch((0,actions/* showPriceVatIncluded */.GR)(priceVatIncludedChecked));
  }; // @ts-ignore


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
    maxW: "6xl",
    px: 0,
    ref: ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetails_Title, {
      title: title,
      subtitle: subtitle,
      brandImage: brandImage,
      brandImageAlt: brandImageAlt
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
      marginY: "m",
      color: "baseNeutral.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Offer, {
      sectionTitle: sectionTitle,
      durationTitle: durationTitle,
      durationValue: durationValue,
      distanceValue: distanceValue,
      distanceTitle: distanceTitle,
      depositTitle: depositTitle,
      depositValue: depositValue,
      depositDescription: depositDescription,
      hasDepositChoice: hasDepositChoice,
      expirationValue: expirationValue,
      onClick: hasSecondaryAction ? onClick : null,
      onHoverMessage: onHoverMessage
    }), hasDepositChoice && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ChooseDeposit, {
        offerData: offerData,
        mt: "l"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
        marginY: "m",
        color: "baseNeutral.700"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetails_Description, {
      fuelTitle: fuelTitle,
      fuelValue: fuelValue,
      transmissionTitle: transmissionTitle,
      transmissionValue: transmissionValue,
      powerTitle: powerTitle,
      powerValue: powerValue,
      priceValue: priceValue,
      priceDescription: priceDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      mt: "-30px",
      textAlign: "right",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        as: "span",
        children: priceVatIncluded ? `IVA inclusa` : `IVA esclusa`
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Switch */.r, {
        ml: "6px",
        colorScheme: "green",
        isChecked: priceVatIncluded,
        float: "right",
        value: "1",
        onChange: togglePriceVatIncluded
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
      marginY: "m",
      color: "baseNeutral.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Actions/* default */.Z, {
      active: active,
      primary: primary,
      hasSecondaryAction: hasSecondaryAction,
      secondary: secondary,
      inline: false
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Simple/* default */.Z, {
      insurances: insurances
    })]
  });
});
OfferDetails_OfferDetails.displayName = 'OfferDetails';
/* harmony default export */ var components_OfferDetails = (OfferDetails_OfferDetails);

/***/ }),

/***/ 49470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const GreenFuelIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#41A476",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M12.578 17.5c.129 0 .235-.105.235-.234v-.938c0-.129-.106-.234-.235-.234h-.703v-4.688h.234c.648 0 1.172.525 1.172 1.172v.815c0 1.104.791 2.109 1.89 2.223 1.26.126 2.329-.864 2.329-2.1V6.97c0-.498-.196-.976-.548-1.327l-2.537-2.538c-.09-.09-.24-.09-.331 0l-.662.663c-.09.09-.09.24 0 .33l1.265 1.27v1.819c0 .823.613 1.502 1.407 1.617v4.71c0 .387-.317.704-.703.704-.387 0-.704-.317-.704-.703v-.938c0-1.424-1.154-2.578-2.578-2.578h-.234V3.906c0-.776-.63-1.406-1.406-1.406H4.844c-.777 0-1.407.63-1.407 1.406v12.188h-.703c-.129 0-.234.105-.234.234v.938c0 .129.105.234.234.234h9.844zm-2.11-9.375H4.845V3.906h5.625v4.219zm0 7.969H4.845V9.53h5.625v6.563z",
        transform: "translate(-975 -440) translate(974 172) translate(1 268)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (GreenFuelIcon);

/***/ }),

/***/ 12505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const GreenPowerIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#41A476",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M16.505 16c.307 0 .6-.158.755-.43.682-1.203 1.073-2.601 1.073-4.094 0-4.497-3.544-8.143-7.916-8.143-4.373 0-7.917 3.646-7.917 8.143 0 1.493.392 2.891 1.074 4.094.154.272.448.43.754.43h12.177zm-.253-1.357H4.582c-.5-.972-.763-2.06-.763-3.167 0-3.742 2.96-6.786 6.598-6.786 3.637 0 6.597 3.044 6.597 6.786 0 1.106-.263 2.195-.762 3.167zM10.27 7.827l.446-1.378c.032-.097.087-.18.135-.266-.13-.078-.273-.135-.434-.135-.486 0-.88.405-.88.904 0 .447.32.8.733.875zm1.662 5.459c.151-.267.244-.574.244-.905 0-.55-.243-1.037-.62-1.369l1.247-3.845c.114-.355-.073-.74-.418-.858-.35-.12-.72.074-.836.429l-1.246 3.845c-.917.061-1.646.838-1.646 1.798 0 .331.093.638.245.905h3.03zM7.338 9.214c.486 0 .88-.405.88-.904 0-.5-.394-.905-.88-.905s-.88.405-.88.905.394.904.88.904zm6.157 0c.486 0 .88-.405.88-.904 0-.447-.32-.801-.734-.875l-.004.018-.536 1.654c.12.063.25.108.394.108zM6.02 12.382c.485 0 .88-.405.88-.905s-.395-.905-.88-.905c-.486 0-.88.406-.88.905 0 .5.394.905.88.905zm8.796 0c.486 0 .88-.405.88-.905s-.394-.905-.88-.905-.88.406-.88.905c0 .5.394.905.88.905z",
        transform: "translate(-975 -496) translate(974 172) translate(1 324)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (GreenPowerIcon);

/***/ }),

/***/ 46378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const GreenTransmissionIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#41A476",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M6.457 17.48h7.693v-.694H6.457v.694zm2.408-5.944h2.878c.256 0 .49.132.582.33l1.153 2.527.555 1.216H6.578l.554-1.216 1.154-2.528c.09-.198.322-.33.579-.33zm1.859-5.116l-.001.001c-.042.117-.219.202-.421.202-.083 0-.166-.014-.234-.04-.066-.028-.15-.077-.182-.157l-.005-.011c-.482-1.304-.716-2.222-.716-2.804 0-.423.51-.768 1.137-.768.628 0 1.14.343 1.14.765 0 .574-.235 1.493-.718 2.812zm.095 1.373v2.566h-.963V7.793c.185.005.4.006.485.006.084 0 .296 0 .478-.006zm4.704 7.706c-.013-.03-1.32-2.9-1.843-4.045-.288-.634-1.023-1.067-1.847-1.096V7.196c.13-.14.223-.289.274-.442.52-1.415.783-2.473.783-3.146 0-1.07-1.161-1.941-2.588-1.941-1.426 0-2.585.87-2.585 1.941 0 .473.135 1.403.78 3.148.06.159.15.306.273.44v3.165c-.82.03-1.555.463-1.846 1.095-.523 1.156-1.813 3.977-1.842 4.04l-.002.003c-.071.158-.095.79-.071 1.877v.003c.001.526.529.954 1.177.954h8.236c.648 0 1.175-.428 1.176-.954.013-.611.021-1.667-.075-1.88z",
        transform: "translate(-975 -468) translate(974 172) translate(1 296)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (GreenTransmissionIcon);

/***/ }),

/***/ 94999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Badges_LimitedOffer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/clock.tsx


const ClockIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12.272 12.673c.228-.214.228-.56 0-.773l-1.033-.968c.753-.875 1.203-1.99 1.203-3.201.002-.761-.175-1.483-.491-2.13.542-.468.882-1.137.882-1.883 0-1.41-1.217-2.551-2.722-2.551-1.1 0-2.049.61-2.477 1.492-.42-.046-.848-.046-1.268 0-.428-.882-1.376-1.492-2.477-1.492-1.505 0-2.722 1.141-2.722 2.551 0 .746.34 1.415.882 1.882-.316.648-.493 1.37-.493 2.129 0 1.212.452 2.326 1.203 3.2l-1.033.969c-.229.214-.229.56 0 .772.228.215.598.215.824 0l1.033-.968c1.98 1.497 4.83 1.513 6.83 0l1.035.97c.228.215.598.215.824 0zm-.946-8.045c-.636-.78-1.507-1.381-2.51-1.714.277-.394.753-.654 1.295-.654.858 0 1.556.654 1.556 1.458 0 .345-.13.661-.34.91zm-8.65 0c-.214-.249-.343-.565-.343-.91 0-.804.698-1.458 1.556-1.458.542 0 1.018.26 1.298.654-1.006.333-1.877.934-2.511 1.714zM7 11.738c-2.365 0-4.278-1.793-4.278-4.01 0-2.21 1.906-4.01 4.278-4.01 2.367 0 4.278 1.796 4.278 4.01 0 2.217-1.913 4.01-4.278 4.01zm1.531-2.25l.44-.602c.09-.125.059-.294-.075-.38L7.68 7.721V5.268c0-.15-.132-.274-.292-.274H6.61c-.16 0-.292.123-.292.274V8.25c0 .091.047.176.127.226l1.677 1.082c.134.084.316.052.408-.07z",
        transform: "translate(-413 -1472) translate(45 1377) translate(344 75) translate(16 16) translate(8 4)"
      })
    })
  })
});

/* harmony default export */ var clock = (ClockIcon);
;// CONCATENATED MODULE: ./src/uikit/Badges/LimitedOffer.tsx


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const LimitedOfferStyle = /*#__PURE__*/(0,styled_components_browser_esm["default"])(index_esm/* Box */.xu).withConfig({
  componentId: "sc-1kch8fu-0"
})(["& svg{display:inline;margin-right:4px;vertical-align:sub;}"]);

const LimitedOffer = _ref => {
  let {
    children
  } = _ref,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LimitedOfferStyle, _objectSpread(_objectSpread({}, others), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Badge */.Ct, {
      bg: "feedbackWarning",
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "0.625rem",
      lineHeight: "15.6px",
      letterSpacing: ".33px",
      rounded: "15px",
      paddingY: ".3rem",
      paddingX: ".5rem",
      textTransform: "initial",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(clock, {}), children]
    })
  }));
};

/* harmony default export */ var Badges_LimitedOffer = (LimitedOffer);

/***/ }),

/***/ 93531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53918);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["icon", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const WithIconStyle = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu).withConfig({
  componentId: "sc-9r4ze0-0"
})(["font-family:Montserrat-Medium,sans-serif;font-size:0.75rem;line-height:15.6px;letter-spacing:0.4px;margin-top:0.25rem;color:", ";& svg{display:inline;vertical-align:bottom;}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.baseNeutral700;
});

const WithIcon = _ref2 => {
  let {
    icon,
    name,
    value
  } = _ref2,
      other = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref2, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WithIconStyle, _objectSpread(_objectSpread({}, other), {}, {
    children: [icon, " ", name, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
      children: value
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (WithIcon);

/***/ }),

/***/ 64673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["value", "description"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const BoxDescription = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  componentId: "sc-zru8zp-0"
})(["display:block;margin-top:0;", ""], src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_4__/* .TextStyles.infoXxsN700MediumDx */ .k.infoXxsN700MediumDx);

const PriceBox = _ref => {
  let {
    value,
    description
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, _objectSpread(_objectSpread({
    color: "baseDark",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "1.5rem",
    lineHeight: "31.2px",
    letterSpacing: "0.86px"
  }, others), {}, {
    children: [value, description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BoxDescription, {
      children: description
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (PriceBox);

/***/ }),

/***/ 12261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["width", "action", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const PrimaryButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_ref, ref) => {
  let {
    width,
    action,
    onClick
  } = _ref,
      props = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const buttonSize = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)(['md', 'lg']);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, _objectSpread(_objectSpread({
    bg: "primaryGreen.300",
    color: "primaryGreen.900",
    fontFamily: "Montserrat-SemiBold",
    fontWeight: "inherit",
    borderRadius: 4,
    overflow: "hidden",
    width: width || '100%',
    size: buttonSize,
    _active: {
      bg: 'primaryGreen.800',
      color: 'baseWhite'
    },
    _hover: {
      bg: props.disabled ? '' : 'primaryGreen.900',
      color: props.disabled ? '' : 'baseWhite'
    },
    _disabled: {
      bg: 'baseNeutral.200',
      color: 'baseNeutral.400',
      cursor: 'default'
    },
    onClick: onClick
  }, props), {}, {
    children: action
  }));
});
/* harmony default export */ __webpack_exports__["Z"] = (PrimaryButton);

/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["title", "width", "action", "disabled", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const SecondaryButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_ref, ref) => {
  let {
    title,
    width,
    action,
    disabled,
    onClick
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const buttonSize = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)(['md', 'lg']);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, _objectSpread(_objectSpread({
    variant: "outline",
    bg: "baseWhite",
    color: "primaryGreen.900",
    fontFamily: "Montserrat-SemiBold",
    borderRadius: 4,
    display: "block",
    overflow: "hidden",
    title: title,
    disabled: disabled,
    width: width || '100%',
    size: buttonSize,
    borderColor: "primaryGreen.300",
    px: {
      base: '0.75rem',
      md: '1rem'
    },
    _active: {
      bg: 'primaryGreen.800',
      borderColor: 'primaryGreen.800',
      color: 'baseWhite'
    },
    _hover: {
      bg: disabled ? '' : 'primaryGreen.900',
      borderColor: disabled ? '' : 'primaryGreen.900',
      color: disabled ? '' : 'baseWhite'
    },
    _disabled: {
      bg: 'baseNeutral.200',
      color: 'baseNeutral.400',
      cursor: 'default'
    },
    onClick: onClick
  }, others), {}, {
    children: action
  }));
});
/* harmony default export */ __webpack_exports__["Z"] = (SecondaryButton);

/***/ }),

/***/ 72954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Simple; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/green_check.tsx


const GreenCheckIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#41A476",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6.617 13.9L2.438 9.72c-.25-.25-.25-.657 0-.908l.91-.91c.25-.25.658-.25.909 0l2.814 2.815 6.03-6.029c.25-.25.658-.25.909 0l.909.91c.25.25.25.658 0 .909l-7.393 7.392c-.251.251-.658.251-.91 0z",
        transform: "translate(-975 -644) translate(974 172) translate(1 472)"
      })
    })
  })
});

/* harmony default export */ var green_check = (GreenCheckIcon);
;// CONCATENATED MODULE: ./src/uikit/Lists/Simple.tsx






const StyledList = /*#__PURE__*/(0,styled_components_browser_esm["default"])(index_esm/* ListItem */.HC).withConfig({
  componentId: "sc-nn6v2b-0"
})(["margin-top:unset !important;& svg{display:inline;margin-bottom:-5px;margin-top:5px;}"]);

const SimpleList = _ref => {
  let {
    insurances
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    paddingY: "s",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* List */.aV, {
      spacing: 3,
      children: insurances.map(item => /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledList, {
        color: "baseBlack",
        fontFamily: "Montserrat-Medium",
        fontSize: "0.75rem",
        letterSpacing: "0.4px",
        textAlign: "left",
        py: "auto",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ListIcon */.DE, {
          as: green_check,
          fontSize: "0.75rem",
          marginTop: ".4rem"
        }), ` ${item}`]
      }, item))
    })
  });
};

/* harmony default export */ var Simple = (SimpleList);

/***/ })

}]);